import {useEffect, useState} from 'react';

export function usePromotionTime(promotion) {
    const [now, setNow] = useState(Date.now);
    const start = promotion?.starts_at, end = promotion?.ends_at;
    useEffect(() => {
        let timeout;
        const update = () => {
            const current = Date.now();
            setNow(current);
            const future = [start, end].map(value => Number(value) * 1000)
                .filter(value => Number.isFinite(value) && value > current);
            if (future.length) timeout = setTimeout(update, Math.min(Math.min(...future) - current + 1, 2147483647));
        };
        update();
        return () => clearTimeout(timeout);
    }, [start, end]);
    return now;
}
